const RATING = {
  DEFAULT: -1,
  BEGINNER: 100,
  INTERMEDIATE: 200,
  PROFICIENT: 300,
  EXPERT: 400,
};

export default RATING;
